import React from 'react';
import { 
    Container,
    Image,
    Text,
    ContentContainer,
    MainContainer,
    Span
 } from './styles/about';



export default function AboutSection({children, ...restProps}) {
    return <Container {...restProps}>{children}</Container>
}


AboutSection.MainContainer = function AboutSectionMainContainer ({children, ...restProps}) {
    return <MainContainer {...restProps}>{children}</MainContainer>
}

AboutSection.ContentContainer = function AboutSectionContentContainer ({children, ...restProps}) {
    return <ContentContainer {...restProps}>{children}</ContentContainer>
}

AboutSection.Image = function AboutSectionImage ({children, ...restProps}) {
    return <Image {...restProps}>{children}</Image>
}

AboutSection.Span = function AboutSectionSpan ({children, ...restProps}) {
    return <Span {...restProps}>{children}</Span>
}

AboutSection.Text = function AboutSectionText ({children, ...restProps}) {
    return <Text {...restProps}>{children}</Text>
}